type Props = {
  fill?: string;
  height?: number;
  width?: number;
};

export default function FlameIcon({
  width = 24,
  height = 24,
  fill = '#FFAA00'
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74715 5.8003C10.1649 14.4018 11.4444 9.90845 11.4444 4.8959V0.765288C11.4444 0.000976937 12.4545 -0.289688 12.8698 0.355132L20.6904 11.1095C21.5457 12.4376 22 13.9792 22 15.5535C22 19.5099 19.1667 22.9132 15.2381 23.6758L14.6157 23.7966C13.2186 24.0678 11.7814 24.0678 10.3843 23.7966L10.1649 23.754C6.00213 22.946 3 19.3399 3 15.1477C3 13.8283 3.30122 12.5259 3.88122 11.3375L6.61944 5.7271C6.85757 5.23919 7.57564 5.2858 7.74715 5.8003Z"
        fill={fill}
      />
    </svg>
  );
}
